import { Button, EButtonColorVariant, EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export const ContactUs = () => {
  const intl = useIntl();
  const email = 'press@outdoorsy.com';

  return (
    <div className="text-white bg-primary-800">
      <div className="text-center section-spacing !max-w-md">
        <Heading variant={EHeadingStyleVariant.H1}>
          <FormattedMessage
            defaultMessage="Want to discuss the findings of this report?"
            id="PCDmWu"
          />
        </Heading>
        <Heading variant={EHeadingStyleVariant.H5} className="mt-4 mb-8">
          <FormattedMessage
            defaultMessage="We’d be excited to hear from you if you’d like to know more, quote the report or discuss the implications of our first edition of ‘Generations in the Wild’"
            id="aBwWqr"
          />
        </Heading>
        <Button
          href={`mailto:${email}`}
          variant={EButtonColorVariant.Tertiary}
          className="text-white !bg-[#A2AA3D] !border-[#A2AA3D]"
          label={intl.formatMessage({ defaultMessage: 'Contact us', id: 'WnQ/AZ' })}
          target="_blank"
        />
      </div>
    </div>
  );
};
